module.exports = __webpack_public_path__ + "img/color-picker-1_en.21860ba.jpg";